
export const en = {
    nav: {
        dashboard: "Dashboard",
        playlists: "Playlists",
        users: "Users",
        settings: "Settings",
        churches: "Churches",
        logout: "Logout",
        darkMode: "Dark Mode",
        lightMode: "Light Mode",
        profile: "Profile",
        general: "General",
        collapse: "Collapse Menu",
        expand: "Expand Menu",
        simulating: "Simulating User",
        stopSimulating: "Stop Simulation",
        material: "Material",
        worship: "Worship",
        cloudFiles: "Cloud Files",
        logs: "System LogView",
        devices: "Devices"
    },
    dashboard: {
        welcome: "Welcome back,",
        stats: "",
        nextEvent: "Next Event",
        nextSunday: "Next Sunday Service",
        activeUsers: "Active Users",
        startPresentation: "Start Presentation",
        noUpcomingEvents: "No upcoming events",
        manageUsers: "Manage Users",
        viewAll: "View All",
        allPlaylists: "All Playlists",
        upcomingPlaylists: "Upcoming Playlists",
        playlistCount: "{{count}} playlist",
        playlistCount_plural: "{{count}} playlists",
        noUpcomingPlaylists: "No upcoming playlists yet",
        createFirstPlaylist: "Create your first playlist to get started with managing your church's worship sessions.",
        noPlaylists: "No playlists yet",
        createFirst: "Create Your First Playlist",
        totalMediaElementsWithChurchId: "Total Media Elements with Church ID",
        totalMaterialFiles: "Total Material Files"
    },
    login: {
        title: "Sign in to ChurchCast",
        email: "Email Address",
        password: "Password",
        submit: "Sign In",
        forgotPassword: "Forgot your password?",
        backToLogin: "Back to Sign In",
        backToWebsite: "Back to Website",
        resetTitle: "Reset Password",
        resetDesc: "Enter your email address and we'll send you a link to reset your password.",
        sendLink: "Send Reset Link",
        linkSent: "Reset link sent!",
        linkSentDesc: "Check your email inbox for further instructions.",
        error: "Invalid credentials.",
        setNewPassword: "Set New Password",
        success: "Success!",
        newPassword: "New Password",
        confirmPassword: "Confirm New Password",
        resetPassword: "Reset Password",
        backToLoginShort: "Back to Login",
        errors: {
            invalidEmail: "User account not found.",
            invalidPassword: "The password you entered is incorrect.",
            generic: "An unexpected error occurred."
        },
        errorOccurred: "An error occurred",
        networkError: "Network error. Please try again.",
        passwordsNoMatch: "Passwords do not match",
        passwordTooShort: "Password must be at least 6 characters long",
        enterEmail: "Enter your email address",
        enterNewPassword: "Enter new password",
        confirmNewPassword: "Confirm new password"
    },
    media: {
        title: "Media Library",
        tabs: {
            files: "Cloud Files",
            youtube: "YouTube Library"
        },
        upload: "Upload File",
        newFolder: "New Folder",
        addVideo: "Add Video",
        addPlaylist: "Add Playlist",
        videoUrl: "YouTube Video URL",
        playlistId: "Playlist ID",
        empty: "No media items found.",
        filesDesc: "Manage files from your connected cloud storage.",
        youtubeDesc: "Manage the collection of YouTube resources available for playlists.",
        sidbarTitle: "Media found",
        dropZone: "Drop files here to upload",
        uploading: "Uploading",
        uploadComplete: "Upload Complete",
        searchMedia: "Search files and videos...",
        songs: "Saved Videos",
        confirmDeletePlaylist: "Are you sure you want to delete this playlist? All videos from this playlist will be removed.",
        cannotDeletePlaylistVideo: "Cannot delete video that is part of a YouTube playlist. Delete the playlist instead.",
        fromPlaylist: "From Playlist",
        playlists: "Playlists",
        videos: "videos",
        tracks: "tracks",
        refresh: "Refresh",
        latestVideos: "Latest videos",
        latestTracks: "Latest tracks",
        moreVideos: "more videos",
        moreTracks: "more tracks",
        collapse: "Collapse",
        expand: "Expand",
        addFromUrlTitle: "Add from URL",
        addFromUrlPlaceholder: "Paste a YouTube Video or Playlist URL",
        addFromUrlDesc: "Paste any YouTube URL. The app will detect if it is a single video or a playlist.",
        adding: "Adding...",
        add: "Add",
        openInYoutube: "Open in YouTube",
        addToPlaylist: "Add to Playlist",
        selectPlaylist: "Select Playlist",
        nextSunday: "Next Services",
        errorTitle: "Error",
        convertToSlides: "Convert to Slides",
        converting: "Converting PDF...",
        conversionComplete: "Slides Created!",
        createNewPlaylist: "Create New Playlist",
        playlistName: "Playlist name",
        existingPlaylists: "Existing Playlists",
        noPlaylists: "No playlists available",
        items: "items",
        playlistCreated: "Playlist created successfully!",
        searchPlaylists: "Search playlists...",
        sort: {
            title: "Sort",
            alphabetical: "Alphabetical",
            date: "Date Added",
            duration: "Duration",
            type: "Type",
            ascending: "Ascending",
            descending: "Descending"
        },
        filter: {
            all: "All",
            youtube: "YouTube",
            spotify: "Spotify"
        },
        search: {
            resultsFor: "Search results for:",
            clear: "Clear",
            noResults: "No files found matching",
            searching: "Searching...",
            inSubfolders: "Searching in subfolders"
        },
        // Additional media translations
        missingFileOrChurchId: "Missing file ID or church ID",
        failedFetchFile: "Failed to fetch file: {status} {statusText}",
        audioFile: "audio.mp3",
        loadingAudio: "Loading audio...",
        errorLoadingAudio: "Error loading audio",
        audioViewerError: "Audio viewer error",
        audioNotDisplayed: "The audio could not be displayed in the browser.",
        browserCompatibility: "This could be due to browser compatibility or audio format issues.",
        downloadAudio: "Download audio",
        noFileData: "No file data available",
        failedLoadAudio: "Failed to load audio",
        download: "Download",
        closeEsc: "Close (ESC)",
        unknownTrack: "Unknown track",
        unknownArtist: "Unknown artist",
        dragPlayer: "Drag player",
        openFullScreen: "Open full screen",
        close: "Close",
        invalidSpotifyUrl: "Invalid Spotify URL",
        pdfDocument: "PDF document",
        failedFetchPdf: "Failed to fetch PDF",
        importedVideo: "Imported video",
        failedSpotifyImport: "Spotify import failed",
        imagePreviewNotAvailable: "Image preview not available",
        videoPreviewNotAvailable: "Video preview not available",
        scanningPdf: "Scanning PDF...",
        unknownVideo: "Unknown video",
        openInSpotify: "Open in Spotify",
        import: "Import",
        previewNotAvailable: "Preview not available",
        failedDownloadFile: "File download failed: {status} {statusText}",
        downloadFailed: "Download failed",
        downloading: "Downloading...",
        downloadFile: "Download file",
        play: undefined,
        filterPlaylist: "Filter main list by this playlist",
        filtered: "filtered",
        clearFilter: "Clear Filter",
        openPlaylist: "Open Playlist",
        selectImages: "Import Images",
        spotifyNotSupported: "Spotify Not Supported",
        spotifyNotSupportedDescription: "Spotify playback is not supported in the browser on iOS devices due to autoplay restrictions.",
        spotifyNotSupportedNote: "Please use the Spotify app directly for music playback.",
        spotifyNotConnected: "Spotify not connected"
    },
    imageSelection: {
        title: "Select Images from {title}",
        description: "Choose the images you'd like to add to your playlist",
        loading: "Loading images...",
        selected: "Selected",
        imagesSelected: "{count} of {total} images selected",
        addImagesToPlaylist: {
            singular: "Add {count} Image to Playlist",
            plural: "Add {count} Images to Playlist"
        },
        cancel: "Cancel",
        imageNotAvailable: "Image not available",
        bibleIllustration: "Bible illustration {number}",
        page: "Page",
        of: "of",
        previous: "Previous",
        next: "Next",
        showingImages: "Showing {start}-{end} of {total} images"
    },
    settings: {
        title: "Church Settings",
        cloudStorage: "Cloud Storage Integration",
        cloudDesc: "Connect a cloud provider to access your files and folders.",
        connectSharepoint: "Connect SharePoint",
        connectDrive: "Connect Google Drive",
        connected: "Connected",
        disconnect: "Disconnect",
        disconnectSharePoint: "Disconnect SharePoint",
        disconnectGoogleDrive: "Disconnect Google Drive",
        disconnectSpotify: "Disconnect Spotify",
        disconnectFirst: "Disconnect First",
        otherProviderConnected: "Other Provider Connected",
        confirmDisconnect: "Are you sure you want to disconnect? This will revoke access to cloud files and may break existing playlists.",
        addBaseFolder: "Add Base Folder",
        addBaseFolderDesc: "Configure multiple base folders to create separate file views in the sidebar",
        menuTitle: "Menu Title",
        menuTitlePlaceholder: "Enter title for sidebar menu",
        addFirstBaseFolder: "Add Your First Base Folder",
        noBaseFoldersConfigured: "No base folders configured",
        connecting: "Connecting...",
        worshipSection: "Worship Section",
        worshipDesc: "Connect your Spotify account and enable slides for songs",
        enableWorship: "Enable Worship Module",
        youtubeIntegration: "YouTube Integration",
        addPlaylist: "Add Playlist ID",
        save: "Save Changes",
        baseFolder: "Base Folder for Media",
        baseFolderDesc: "Select the folder that will be used as the base for your media files and playlist builder.",
        setBaseFolderFirst: "Set Base Folder First",
        setBaseFolderFirstDesc: "You need to set a base folder before adding additional sidebar folders. The sidebar folders must be within the base folder.",
        privacyWarning: "Privacy Warning",
        privacyWarningDesc: "Your base folder is set to the root directory. This means the file index will have access to ALL files and folders in your cloud storage. Consider selecting a more specific folder for better privacy.",
        change: "Change",
        remove: "Remove",
        selectFolder: "Select Folder",
        disconnectConfirmTitle: "Disconnect Connection?",
        disconnectConfirmMessage: "Are you sure you want to disconnect from <strong>{provider}</strong>?<br/><br/><strong>Warning:</strong> Access to all cloud files will be lost and existing playlists may no longer work.",
        cancel: "Cancel",
        disconnectAction: "Disconnect",
        folderPickerTitle: "Select Folder",
        currentFolder: "Current folder:",
        selectThisFolder: "Select This Folder",
        folderEmpty: "This folder is empty or contains no subfolders.",
        enableWorshipDesc: "Enable or disable the Worship playlist module globally.",
        enableYoutube: "Enable YouTube Module",
        enableSpotify: "Enable Spotify Module",
        enableSlides: "Enable Slides Module",
        enableYoutubeDesc: "Enables integration of YouTube videos in playlists.",
        enableSpotifyDesc: "Enables integration of Spotify music in playlists.",
        enableSlidesDesc: "Enables integration of slides and presentations.",
        indexingError: "Failed to build index",
        spotifyDisconnect: "Failed to disconnect Spotify",
        fileIndexing: "File Indexing",
        fileIndexingDesc: "Build an index of your cloud files for fast searching across all folders and subfolders",
        enableFileIndexing: "Enable File Indexing",
        enableFileIndexingDesc: "When enabled, creates a searchable index of all your cloud files for faster search in playlists",
        indexedDataInfo: "Indexed Data Information",
        indexedDataDescription: "The following data is stored in the file index:",
        indexedFields: {
            id: "File ID from cloud provider",
            name: "File/folder name",
            path: "Full path from root",
            type: "File type (FILE or FOLDER)",
            parentId: "Parent folder ID",
            size: "File size in bytes",
            modifiedAt: "Last modified date",
            createdAt: "Date when indexed",
            lastIndexed: "Last time file was indexed"
        },
        fileIndexingNote: "When enabled, this activates fast search functionality in playlists and enables searching across all your cloud files instantly.",
        searchIndexStatus: "Search Index Status",
        noIndexCreated: "No index created yet",
        createIndex: "Create Index",
        rebuildIndex: "Rebuild Index",
        building: "Building...",
        buildingIndex: "Building index...",
        filesIndexed: "Files Indexed",
        foldersScanned: "Folders Scanned",
        buildTime: "Build Time",
        lastUpdated: "Last updated:",
        indexed: "Indexed",
        notconnected: "Not Connected",
        smartUpdate: "Smart Update",
        fullRebuild: "Full Rebuild",
        connectSpotify: "Connect Spotify",
        spotifyDisconnectConfirmMessage: "Are you sure you want to disconnect from <strong>Spotify</strong>?<br/><br/><strong>Warning:</strong> All Spotify playlists and songs will be deactivated and no longer accessible.",
        rateLimited: "Rate limited - try again in {minutes} minutes",
        rateLimitTooltip: "To protect our servers, index updates are only possible at specified intervals."
    },
    playlist: {
        title: "Manage Playlists",
        create: "New Playlist",
        edit: "Edit",
        name: "Playlist Name",
        date: "Date",
        tabs: {
            worship: "Worship",
            material: "Material / Slides"
        },
        order: "Order of Service",
        worshipFirst: "Worship First",
        materialFirst: "Material First",
        offlineMode: "Make Available Offline",
        downloading: "Caching...",
        searchYoutube: "Search YouTube or Paste URL",
        selectFolder: "Select Folder",
        fileBrowser: "File Browser",
        selectedItems: "Selected Items",
        noItems: "No items selected.",
        filterSource: "Source / Playlist",
        allSources: "All Sources (Library & Playlists)",
        sourceLibrary: "My Saved Library",
        startPresentation: "Present",
        pastPlaylistsAvailable: "{count} past playlist{plural} available",
        showPast: "Show Past",
        hidePast: "Hide Past"
    },
    presentation: {
        exit: "Exit Presentation",
        next: "Next",
        prev: "Previous",
        end: "End of Presentation"
    },
    users: {
        title: "User Management",
        user: "User",
        language: "Language",
        addUser: "Add User",
        editUser: "Edit User",
        deleteUser: "Delete User",
        simulate: "Simulate",
        filterChurch: "Filter by Church",
        allChurches: "All Churches",
        role: "Role",
        church: "Church",
        name: "Name",
        email: "Email",
        save: "Save User",
        cancel: "Cancel",
        changePass: "Change Password",
        newPass: "New Password",
        password: "Password",
        newPassword: "New Password",
        newPasswordPlaceholder: "New Password (leave blank to keep current)",
        passwordPlaceholder: "Password will be sent via email",
        passwordHelpText: "A temporary password will be generated and sent to the user's email address.",
        // Service Pin related translations
        servicePinRequired: "Service PIN Required",
        servicePinRequiredDesc: "To simulate user {name} from {church}, please enter the service PIN for that church.",
        servicePin: "Service PIN",
        servicePinPlaceholder: "ABC123",
        simulateUser: "Simulate User",
        invalidServicePin: "Invalid service PIN",
        failedValidateServicePin: "Failed to validate service PIN",
        pleaseEnterServicePin: "Please enter a service PIN",
        roles: {
            SUPER_ADMIN: "Super Admin",
            CHURCH_ADMIN: "Church Admin",
            EDITOR: "Editor",
            USER: "User"
        }
,
        roleInformation: "Role Information",
        roleExplanations: {
            CHURCH_ADMIN: "Can manage users, settings, and all content for their church.",
            EDITOR: "Can create and edit playlists and content.",
            USER: "Can view and present playlists."
        }
    },
    churches: {
        title: "Church Management",
        add: "Add Church",
        edit: "Edit Church",
        name: "Church Name",
        address: "Address",
        save: "Save Church",
        enableWorship: "Enable Worship Module",
        enableWorshipDesc: "Enables the worship module for this church.",
        enableMaterial: "Enable Material/Media Library Module",
        enableMaterialDesc: "Enables material and media library features for this church."
    },
    footer: {
        copyright: "© {year} ChurchCast. All rights reserved.",
        support: "Support",
        impressum: "Legal Notice",
        privacy: "Privacy Policy",
        changelog: "Changelog"
    },
    common: {
        close: "Close",
        cancel: "Cancel",
        delete: "Delete",
        only: "only",
        deletePlaylist: "Delete Playlist",
        deletePlaylistConfirm: "Are you sure you want to delete \"{title}\"? This action cannot be undone.",
        error: "Error",
        errorOccurred: "An error occurred",
        filter: "Filter",
        filters: "Filters",
        clear: "Clear All",
        all: "All",
        loading: "Loading...",
        showing: "Showing",
        to: "to",
        of: "of",
        entries: "entries"
    },
    admin: {
        // Device Management translations
        deviceManagement: "Device Management",
        manageDeviceConnections: "Manage Android TV device connections and limits",
        deviceLimits: "Device Limits",
        deviceLimit: "Device Limit",
        devices: "Devices",
        currentlyConnected: "Currently Connected",
        pendingConnections: "Pending Connections",
        requested: "Requested",
        approve: "Approve",
        reject: "Reject",
        connectedDevices: "Connected Devices",
        noDevicesConnected: "No devices connected yet",
        devicesWillAppear: "Devices will appear here once they connect via QR code",
        connected: "Connected",
        disconnect: "Disconnect",
        setDeviceLimit: "Set Device Limit",
        setMaxDevicesDescription: "Set the maximum number of devices that can connect to your church account.",
        enterDeviceLimit: "Enter device limit (1-100)",
        cancel: "Cancel",
        updateLimit: "Update Limit",
        // Error messages
        failedApproveDevice: "Failed to approve device",
        deviceRejectionNotImplemented: "Device rejection not yet implemented",
        confirmDisconnectDevice: "Are you sure you want to disconnect this device?",
        failedDisconnectDevice: "Failed to disconnect device",
        invalidDeviceLimit: "Please enter a valid number between 1 and 100",
        failedUpdateDeviceLimit: "Failed to update device limit",
        accessDenied: "Access denied. Administrator rights required."
    },
    logs: {
        totalLogs: "Total LogView",
        errors: "Errors",
        warnings: "Warnings",
        info: "Info",
        level: "Level",
        source: "Source",
        userId: "User ID",
        churchId: "Church ID",
        startDate: "Start Date",
        endDate: "End Date",
        timestamp: "Timestamp",
        message: "Message",
        user: "User",
        church: "Church",
        noLogs: "No logs found",
        exportLogs: "Export LogView",
        exportFormat: "Export Format",
        cleanupLogs: "Cleanup Old LogView",
        cleanupWarning: "Warning",
        cleanupWarningDesc: "This action will permanently delete logs older than the specified number of days. This cannot be undone.",
        keepDays: "Keep logs for (days)",
        cleanupNow: "Cleanup Now",
        showing: "Showing",
        to: "to",
        of: "of",
        entries: "entries",
        loading: "Loading...",
        filter: "Filter",
        clear: "Clear All",
        all: "All",
        export: "Export",
        cleanup: "Cleanup",
        cancel: "Cancel",
        exporting: "Exporting...",
        cleaning: "Cleaning...",
        downloadFiles: "Download Files",
        logFileType: "Log File Type",
        combinedLogs: "Combined LogView",
        errorLogs: "Error LogView",
        securityLogs: "Security LogView",
        date: "Date",
        optional: "optional",
        leaveEmptyForToday: "Leave empty for today's log file",
        download: "Download"
    },
    cookies: {
        title: "Cookies and Privacy",
        description: "We use cookies to provide you with the best possible experience. Some cookies are essential for the basic functions of the website, while others help us improve the website and show you relevant content.",
        customize: "Customize",
        acceptAll: "Accept All",
        rejectAll: "Reject All",
        preferences: "Cookie Settings",
        preferencesDescription: "Choose which types of cookies you want to accept. You can change your selection at any time.",
        necessary: "Necessary Cookies",
        necessaryDescription: "These cookies are essential for the basic functions of the website and cannot be disabled.",
        functional: "Functional Cookies",
        functionalDescription: "These cookies enable enhanced features such as personalization and may be set by us or third-party providers.",
        analytics: "Analytics Cookies",
        analyticsDescription: "These cookies help us understand how visitors interact with the website by collecting and reporting information anonymously.",
        marketing: "Marketing Cookies",
        marketingDescription: "These cookies are used to show visitors relevant advertisements and measure the effectiveness of advertising campaigns.",
        thirdPartyServices: "Third-party Services",
        youtubeService: "Used for YouTube video integration",
        spotifyService: "Used for Spotify music integration",
        googleService: "Used for Google Drive integration",
        sharepointService: "Used for SharePoint integration",
        cancel: "Cancel",
        savePreferences: "Save Preferences"
    },
    landing: {
        nav: {
            home: "Home",
            features: "Features", 
            benefits: "Benefits",
            pricing: "Pricing",
            contact: "Contact",
            login: "Login"
        },
        hero: {
            title: "Use Modern Media with {name} Easily!",
            subtitle: "The modern platform for Kids Church and Signage",
            ctaDemo: "Free Tour",
            ctaLearnMore: "Learn More"
        },
        overview: {
            title: "What is ChurchCast?",
            founderName: "Josua Barron",
            founderTitle: "Founder & CEO of ChurchCast",
            founderDescription: "As a passionate developer and believer, I created ChurchCast to help church communities spread their message with cutting-edge technology. With years of experience in software development and a deep understanding of church needs, I create solutions that seamlessly blend tradition with innovation."
        },
        features: {
            title: "Key Features",
            items: {
                preparation: {
                    title: "Preparation",
                    description: "Church Cast supports you in simple steps when preparing your kids church"
                },
                presentation: {
                    title: "Live Presentation", 
                    description: "Seamless presentation of videos, images, PDFs and PowerPoint presentations during kids church"
                },
                worship: {
                    title: "Worship Management",
                    description: "Manage songs and playlists for kids church. Integration with Spotify and YouTube"
                },
                cloud: {
                    title: "Cloud Storage",
                    description: "Secure connection to your cloud storage for all your media files with automatic synchronization"
                },
                multiUser: {
                    title: "Multi-User System",
                    description: "Manage permissions for different team members and volunteers"
                },
                signage: {
                    title: "Signage",
                    description: "Signage module coming soon"
                }
            }
        },
        benefits: {
            title: "Why Choose ChurchCast?",
            subtitle: "The benefits that make the difference",
            items: {
                timeSaving: {
                    title: "Time Saving",
                    description: "Reduce preparation time with our intelligent tools"
                },
                costEfficiency: {
                    title: "Cost Efficiency", 
                    description: "One solution for all your needs - no more expensive individual licenses required"
                },
                easyUse: {
                    title: "Easy to Use",
                    description: "Intuitive user interface that even technically less experienced team members can master quickly"
                }
            }
        },
        contact: {
            title: "Ready for the Next Step?",
            subtitle: "Schedule a free tour or contact us",
            email: {
                title: "Email",
                address: "kontakt@josua-barron.de"
            },
            address: {
                title: "Address",
                lines: ["123 Main Street", "12345 Sample City"]
            },
            form: {
                namePlaceholder: "Your Name",
                emailPlaceholder: "Your Email", 
                churchPlaceholder: "Church Community",
                interestPlaceholder: "Interest in...",
                interestOptions: {
                    demo: "Free Demo",
                    pricing: "Pricing Information", 
                    support: "Technical Support",
                    partnership: "Partnership"
                },
                messagePlaceholder: "Your Message",
                submitButton: "Send Message",
                submitting: "Sending...",
                successMessage: "Thank you! Your message was sent successfully.",
                errorMessage: "Sorry, an error occurred while sending your message. Please try again."
            }
        },
        footer: {
            tagline: "A modern solution for digital church",
            productSection: "Product",
            supportSection: "Support",
            companySection: "Company",
            helpCenter: "Help Center",
            aboutUs: "About Us",
            privacy: "Privacy",
            copyright: "All rights reserved."
        },
        floatingCards: {
            liveStreaming: "Live Streaming",
            worship: "Worship",
            community: "Community"
        },
        pricing: {
            title: "ChurchCast Pricing",
            setup: "One-time setup",
            monthly: "Per device/month",
            description: "Flexible pricing based on the number of devices in your church",
            includes: "All plans include:",
            features: [
                "Preparation directly from the material",
                "Advanced Presentation Tools",
                "Spotify Integration",
                "Multi-User Support"
            ],
            guarantee: {
                title: "30-Day Money Back Guarantee",
                description: "Try ChurchCast risk-free. If you're not satisfied within 30 days, we'll refund your setup fee."
            },
            churchPlants: "For church plants: Setup fee waived, only €5/month per device for the first year.",
            requestDemo: "Request Demo"
        }
    },
    remote: {
        title: "Remote Control",
        back: "Back",
        play: "Play/Pause",
        forward: "Forward",
        notSet: "Not set",
        recorded: "Recorded",
        help: "Click on a button and press the key you want to assign. The button will turn green when a key is set."
    },
    tvLogin: {
        title: "TV Login",
        description: "Scan the QR code with your phone to login",
        generateQrCode: "Generate QR Code",
        qrCodeExpired: "QR code has expired",
        loginCancelled: "Login was cancelled",
        failedCheckLoginStatus: "Failed to check login status",
    },
    qrDashboard: {
        title: "QR Dashboard",
        showHidden: "Show Past",
        hideHidden: "Hide Past",
        noPlaylists: "No playlists available",
        noPlaylistsHint: "All playlists are scheduled for future dates",
        enableHidden: 'Enable "Show Past" to see older playlists',
        play: "Play",
        items: "items",
        scheduled: "Scheduled",
        left: "Left",
        right: "Right",
        playKey: "Play",
        playlistCount: "Total playlists",
        logout: "Logout",
        selected: "Selected",
        playlists: "playlists",
        description: "Scan the QR code below with your phone to log in quickly.",
        generateQrCode: "Generate QR Code",
        generatingQrCode: "Generating QR Code...",
        qrCodeExpired: "QR code expired. Please generate a new one.",
        loginCancelled: "Login cancelled.",
        failedCheckLoginStatus: "Failed to check login status. Please try again.",
        failedGenerateQrCode: "Failed to generate QR code. Please try again.",
        scanWithPhone: "Scan with Phone",
        backToDashboard: "Back to Dashboard",
        accessDenied: "Access Denied",
        accessDeniedMessage: "This page is only available for viewers. Please use the regular login page.",
        sessionExpired: "Session expired. Please try again."
    },
    qrLogin: {
        title: "Authenticate Session",
        sessionExpiresIn: "Session expires in:",
        qrSessionExpired: "QR code session has expired. Please scan a new QR code.",
        emailRequired: "Email is required",
        passwordRequired: "Password is required",
        invalidEmail: "Please enter a valid email address",
        loginFailed: "Login failed",
        networkError: "Network error. Please try again.",
        emailPlaceholder: "Enter your email",
        passwordPlaceholder: "Enter your password",
        successMessage: "Session authenticated successfully! Redirecting...",
        authenticateButton: "Authenticate"
    }
};